<template>
  <div class="sr-wrap sr-wrap--center">
    <div class="sr-box sr-box--mini">
      <div class="sr-box__header">
        <div class="sr-box__title">{{t('user.register.title.text_1')}}</div>
      </div>
      <div :class="['sr-box__content',localCN?'':'error-static']">
        <el-form ref="formRef" :model="form.fields" :rules="form.rules">
          <!--邮箱信息-->
          <p class="register-info">{{t('user.register.title.text_2')}}</p>
          <el-form-item prop="email">
            <el-input v-model="form.fields.email" :placeholder="form.schema.email.label" @blur="handleEmailBlur"></el-input>
          </el-form-item>
          <el-form-item prop="emailCode">
            <div class="sr-box__comb-item">
              <div class="comb-item__input">
                <el-input v-model="form.fields.emailCode" :placeholder="form.schema.emailCode.label"></el-input>
              </div>
              <div class="comb-item__btn">
                <sr-email-code-btn :email="form.fields.email" v-model:email-id="form.fields.emailId" :disabled="DISABLED.EMAIL_CODE" type="3" />
              </div>
            </div>
          </el-form-item>
          <p class="register-info">{{t('user.register.title.text_3')}}</p>
          <div>
            <div class="sr-box__comb-item">
              <div class="comb-item__select">
                <sr-zone-number v-model:zone-number="form.fields.zoneNumber"></sr-zone-number>
              </div>
              <el-form-item prop="mobile" style="flex:1">
                <div class="comb-item__input">
                  <el-input v-model="form.fields.mobile" :placeholder="form.schema.mobile.label" @blur="handlePhoneBlur"></el-input>
                </div>
              </el-form-item>
            </div>
          </div>
          <el-form-item prop="mobileCode">
            <div class="sr-box__comb-item">
              <div class="comb-item__input">
                <el-input v-model="form.fields.mobileCode" :placeholder="form.schema.mobileCode.label"></el-input>
              </div>
              <div class="comb-item__btn">
                <sr-cellphone-code-btn :cellphone="form.fields.mobile" :zone-number="form.fields.zoneNumber" v-model:sms-id="form.fields.mobileId" />
              </div>
            </div>
          </el-form-item>
          <p class="register-info">{{t('user.register.title.text_4')}}</p>
          <el-form-item prop="password">
            <div class="password-wrap">
              <el-input v-model="form.fields.password" :placeholder="form.schema.password.placeholder" :type="passwordVisible?'text':'password'"></el-input>
              <div class="icon" @click="passwordVisible = !passwordVisible">
                <svg-icon :icon-class="passwordVisible?'眼睛':'闭眼睛'"/>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="confirmPwd">
            <div class="password-wrap">
              <el-input v-model="form.fields.confirmPwd" :placeholder="form.schema.confirmPwd.label" :type="passwordAgainVisible?'text':'password'"></el-input>
              <div class="icon" @click="passwordAgainVisible = !passwordAgainVisible">
                <svg-icon :icon-class="passwordAgainVisible?'眼睛':'闭眼睛'"/>
              </div>
            </div>
          </el-form-item>
          <p class="register-info">{{form.fields.inviteCode?t('user.register.title.text_6'):t('user.register.title.text_5')}}</p>
          <el-form-item prop="recommendName">
            <el-input v-if="form.fields.inviteCode" disabled v-model="form.fields.inviteCode" :placeholder="form.schema.recommendName.label" type="text"></el-input>
            <el-input v-else v-model="form.fields.recommendName" :placeholder="form.schema.recommendName.label" type="text"></el-input>
          </el-form-item>

          <el-row>
            <el-form-item prop="protocol">
              <el-checkbox-group v-model="form.fields.protocol">
                <el-checkbox>
                  <span>{{t('user.register.content.text_3')}}</span>
                  <a class="a" target="_blank" :href="memberProtocol" v-if="localCN">{{t('user.register.content.text_3_1')}} </a>
                  <span v-if="localCN">{{t('user.register.content.text_3_2')}}</span>
                  <a class="a" target="_blank" :href="privacyProtocol"> {{t('user.register.content.text_3_3')}}</a>
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item prop="privacyCrossBorder">
              <el-checkbox-group v-model="form.fields.privacyCrossBorder">
                <el-checkbox>
                  <span>{{t('user.register.content.text_3_5')}}</span>
                  <a class="a" target="_blank" :href="privacyProtocol">{{t('user.register.content.text_3_3')}}</a>
                  <span>{{t('user.register.content.text_3_6')}}</span>
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div class="sr-box__footer">
        <div class="sr-box__btn">
          <el-button type="primary" @click="register">{{t('user.register.content.text_5')}}</el-button>
          <div class="a to-login-operation" @click="toLogin">{{t('user.register.content.text_4')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, computed } from 'vue'
import { commonComp, formComp, validatorComp } from '@/compositions'
import { getQueryObject, routeTo } from '@/utils'
import SrZoneNumber from '@/components/SrZoneNumber'
import SrCellphoneCodeBtn from '@/components/SrCellphoneCodeBtn'
import SrEmailCodeBtn from '@/components/SrEmailCodeBtn'
import { RegisterReq } from '@/domain/modules/register'
import { register } from '@/api/modules/user'
import { useI18n } from '@/plugins/i18n'
import { encryptUtils, commonUtils, vab } from '@libs/utils'
import fileComp from "@/compositions/modules/file"

export default {
  name: 'Register',
  components: {
    SrZoneNumber,
    SrCellphoneCodeBtn,
    SrEmailCodeBtn
  },
  setup() {
    const { createForm } = formComp()
    const { validateConfirmPwd } = validatorComp()
    const { dict } = commonComp()
    const { t } = useI18n()
    const { template } = fileComp()

    const showPassword = reactive({
      passwordVisible: false,
      passwordAgainVisible: false
    })

    // todo - comp
    const scopedComp = { dict, t }

    // todo - refs
    const refs = reactive({ formRef: null })

    const scopedComputed = {
      DISABLED: computed(() => {
        return {
          EMAIL_CODE: (() => {
            return state.enabledCfg.email
          })()
        }
      })
    }

    // todo - data
    const state = reactive({
      form: createForm({ items: RegisterReq }),
      enabledCfg: { email: false },
      memberProtocol: template.memberProtocol,
      privacyProtocol: template.privacyProtocol
    })

    state.form.fields.protocol = []
    state.form.fields.privacyCrossBorder = []
    state.form.fields.inviteCode = getQueryObject()?.inviteCode || ''

    // todo - methods
    const scopedMethods = {
      handleEmailBlur: () => {
        state.form.fields.email = state.form.fields.email.trim()
        refs.formRef.validateField('email', valid => {
          state.enabledCfg.email = !valid
        })
      },
      handlePhoneBlur: () => {
        state.form.fields.mobile = state.form.fields.mobile.trim()
      },
      register: commonUtils.throttle(function() {
        const form = commonUtils.clone(state.form.fields)
        refs.formRef.validate(async valid => {
          if (valid) {
            if (!form.emailId || !form.mobileId) return vab.baseMessage(!form.emailId ? t('global.bindEmailDialog.content.text_5') : t('global.bindEmailDialog.content.text_5'), 'error')
            form.password = encryptUtils.encrypt(form.password)
            form.confirmPwd = encryptUtils.encrypt(form.confirmPwd)
            await register(form)
            if (/mobile/i.test(navigator.userAgent)) return routeTo('/register-success')
            routeTo('/login')
          }
        })
      }),
      toLogin: () => {
        routeTo('/login')
      }
    }

    // todo - hooks
    onBeforeMount(() => {
      state.form.rules.confirmPwd.push({
        trigger: 'blur',
        validator: (rule, value, callback) => validateConfirmPwd(rule, value, callback, { password: state.form.fields.password })
      })
    })

    return {
      ...scopedComp,
      ...toRefs(refs),
      ...toRefs(state),
      ...scopedComputed,
      ...scopedMethods,
      ...toRefs(showPassword),
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .sr-box--mini {
    margin: 120px 0;
  }

  @media screen and (max-width: 620px) {
    .sr-box--mini {
      margin-top: 0;
    }
  }

  .sr-box .sr-box__header {
    padding: 10px 10px 0;
  }

  .register-info {
    color: #666666;
  }

  .password-wrap {
    width: 100%;
    box-sizing: border-box;
    position: relative;

    .icon {
      font-size: 15px;
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
    }
  }

  .sr-wrap {
    height: auto;
  }

  :deep(.el-checkbox) {
    white-space: normal;
  }

  .to-login-operation {
    width: 100%;
    margin-top: 10px;
    text-align: center;
  }
</style>
